import * as LocalStorage from '../localStorage';

const Env = process.env.NODE_ENV;
// const API = Env === 'development' ? process.env.REACT_APP_DEV_BASE_URL : process.env.REACT_APP_PRODUCT_BASE_URL;
const API = process.env.REACT_APP_DEV_BASE_URL;

const authHeader = () => ({
    Authorization: `Bearer ${LocalStorage.getItem('ACCESS_TOKEN')}`,
});
export { API, authHeader };
